import React, { useState, useEffect } from 'react'
import { WingBlank, WhiteSpace, Card, Modal, Flex, Tabs } from 'antd-mobile'
import { getLinked } from '@/utils/userHelper'
import request from '@/api/request'
import { useFormatMessage } from '@/locales'
import DefaultImg from '@/components/DefaultImg'
import { observer } from 'mobx-react-lite'
import { useStore } from '@/store'
import './index.scss'

interface AdvertItem {
  url: string
  title: string
  price: string
  detail: string
  [key: string]: any
}

interface CategoryItem {
  type: string
  list: AdvertItem[]
}

interface AdvertDetailModalProps {
  visible?: boolean
}

const AdvertDetailModal: React.FC<AdvertDetailModalProps> = props => {
  const { visible } = props
  const [loading, setLoading] = useState<boolean>(true)
  const [categories, setCategories] = useState<CategoryItem[]>([])
  const intlMsg = useFormatMessage()
  const { songStore } = useStore()

  useEffect(() => {
    if (songStore.advertDetailVisible) {
      fetchAdvertList()
    }
  }, [songStore.advertDetailVisible])

  const fetchAdvertList = async () => {
    try {
      setLoading(true)
      const linked = await getLinked()

      // 调用广告列表接口
      const response = await request.post('advertDtail', {
        linked: linked || '',
      })
      const list = Array.isArray(response.list) ? response.list : []
      setCategories(list)
    } finally {
      setLoading(false)
    }
  }

  const renderTabContent = (categoryItems: AdvertItem[]) => (
    <div className="advert-list">
      {categoryItems.map((item, index) => (
        <Card key={index} className="advert-card">
          <div className="advert__item--content">
            <div className="advert__item--img">
              <DefaultImg
                src={item.url}
                alt={item.title}
                style={{
                  width: '100%',
                  height: '100%',
                  borderRadius: '8px',
                }}
              />
            </div>
            <div className="advert__item--info">
              <div className="advert__item--title">{item.title}</div>
              <div className="advert__item--price">{item.price}</div>
              <div className="advert__item--desc">{item.detail}</div>
            </div>
          </div>
        </Card>
      ))}
    </div>
  )

  return (
    <Modal
      closable
      popup
      visible={songStore.advertDetailVisible}
      onClose={() => songStore.updateAdvertDetailVisible(false)}
      animationType="slide-up"
      className="advert-detail-modal"
    >
      <div className="advert-detail-modal-wrap">
        <div className="section-title">
          <span>{intlMsg['const.product.list'] || 'List of items'}</span>
        </div>

        <div className="advert-content">
          <WingBlank size="lg">
            {categories.length > 0 && (
              <Tabs
                tabs={categories.map(cat => ({ title: cat.type }))}
                swipeable={false}
                animated={false}
              >
                {categories.map((category, index) => (
                  <div key={index}>{renderTabContent(category.list)}</div>
                ))}
              </Tabs>
            )}
            <WhiteSpace size="lg" />
            <WhiteSpace size="lg" />
          </WingBlank>
        </div>
      </div>
    </Modal>
  )
}

export default observer(AdvertDetailModal)
